export default __webpack_public_path__ + "static/media/snapchat.553791c2.png";